import {useRef, useState} from "react";
import {AdminAnalyticsApi, IPlanDrilldownResponse} from "../../../../api/AdminAnalyticsApi";

interface Range {
    startDate: string;
    endDate: string;
}

/**
 * Shared expand/fetch logic for the three plan-drilldown tables (engagement, client
 * adoption, feature usage). Toggling a plan open fetches its drilldown; toggling it
 * closed clears the data.
 */
export function usePlanDrilldown(range: Range, country: string) {
    const [expanded, setExpanded] = useState<string | null>(null);
    const [data, setData] = useState<IPlanDrilldownResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    // Guards against out-of-order responses: only the latest toggle's fetch may update state.
    const requestId = useRef(0);

    const toggle = (planName: string) => {
        if (expanded === planName) {
            requestId.current++;
            setExpanded(null);
            setData(null);
            return;
        }
        const id = ++requestId.current;
        setExpanded(planName);
        setLoading(true);
        setData(null);
        AdminAnalyticsApi.getPlanDrilldown(planName, range.startDate, range.endDate, country || undefined)
            .then((result) => {
                if (id !== requestId.current) return;
                setData(result.data ?? null);
                setLoading(false);
            })
            .catch(() => {
                if (id !== requestId.current) return;
                setData(null);
                setLoading(false);
            });
    };

    return {expanded, data, loading, toggle};
}
